import React from 'react';
import { motion } from 'framer-motion';
import { Crown } from 'lucide-react';
export function EsterStory() {
  return <section className="py-10 px-5 relative overflow-hidden" data-id="element-59">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-500/5 rounded-full blur-3xl -z-10" data-id="element-60"></div>

      <div className="max-w-lg mx-auto" data-id="element-61">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6" data-id="element-62">
          <div className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-navy-800 border border-gold-500/30 mb-4 text-gold-400" data-id="element-63">
            <Crown size={20} strokeWidth={1.5} data-id="element-64" />
          </div>
          <h2 className="font-serif text-xl sm:text-2xl text-cream-100 leading-snug" data-id="element-65">
            Existe una mujer en la Biblia que vivió exactamente lo que tú estás
            viviendo.
          </h2>
          <p className="font-script text-4xl text-gold-400 mt-2 text-glow" data-id="element-66">
            Ester.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-3 text-[14px] sm:text-[15px] leading-relaxed text-cream-300/90 font-light" data-id="element-67">
          <p data-id="element-68">
            Llegó a un palacio sin pedirlo. Vivió en silencio por años, sin
            entender por qué estaba ahí. No sabía que estaba siendo preparada.
            No sabía que había un momento específico para el cual Dios la había
            posicionado.
          </p>
          <p className="font-serif text-lg text-cream-100 italic text-center py-2" data-id="element-69">
            Hasta que ese momento llegó.
          </p>
          <p data-id="element-70">Y cuando llegó... todo cobró sentido.</p>
          <p data-id="element-71">
            El proceso duro. La espera larga. El anonimato. La formación
            silenciosa.
          </p>

          <div className="bg-gradient-to-b from-navy-800/80 to-transparent p-4 rounded-sm border-t border-gold-500/20 text-center mt-5" data-id="element-72">
            <p className="text-cream-200 text-sm mb-1" data-id="element-73">Todo tenía un nombre.</p>
            <p className="font-serif text-2xl text-gold-400 uppercase tracking-widest" data-id="element-74">
              Preparación.
            </p>
          </div>

          <div className="text-center mt-6" data-id="element-75">
            <p className="text-cream-300 text-sm mb-1" data-id="element-76">
              Y la pregunta que quiero que te hagas hoy es esta:
            </p>
            <p className="font-serif text-xl text-cream-100" data-id="element-77">
              ¿Y si tu historia también tiene ese nombre?
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}